<template>
<div>
	<el-container style="height: 100vh;min-height: 600px;min-width: 1200px;">
		<el-aside width='230px' class="bg-main " style="float: left;">
			<el-container style="height: 100vh;">
				<el-header style="padding: 0px;">
					<img src="../../public/img/log2.png" style="margin-top: 7px;">
				</el-header>
				<el-main class="mt20 mymenu">
					<!-- 导航菜单 -->
					<my-menu></my-menu>
				</el-main>
			</el-container>
		</el-aside>
		<el-container>
			<el-header class="f-l" style="padding: 0px;" height="70px">
				<my-head></my-head>
			</el-header>
			<el-main style="padding: 0px;">
				<my-tab></my-tab>
			</el-main>
		</el-container>
	</el-container>
	<line-list></line-list>
</div>
</template>

<script>
	import MyMenu from "./index/mymenu.vue";
	import MyHead from "./index/myhead.vue";
	import MyTab from "./index/mytab.vue";
	import LineList from "./index/linelist.vue"
	import { mapGetters,mapMutations } from 'vuex'
	export default{
		name:"index",
		data() {
			return {
				
			}
		},
		components:{
			MyMenu,MyHead,MyTab,LineList
		},
		computed:{
			...mapGetters('Tabs',['getrouter','getindex']),
			...mapGetters('Library',['getLineList']),
		},
		methods:{
			...mapMutations(['setsize']),
			...mapMutations("Tabs",['tabinit']),
			beforeunload(e){
				let obj=this.getlinenum()
				if(obj.up>0||obj.down>0){
					e.preventDefault()
					e.returnValue=""
					let str="有"
					if(obj.up>0){
						str+=obj.up+"个文件正在上传,"
					}
					if(obj.down>0){
						str+=obj.down+"个文件正在下载，"
					}
					str+="确定要关闭页面吗？"
					console.log(str)
					return str
				}
			},
			getlinenum(){
				let obj={up:0,down:0}
				for(let i=0;i<this.getLineList.up.length;i++){
					let test=this.getLineList.up[i].file
					if(test.nowsize<test.size){
						obj.up++
					}
				}
				for(let i=0;i<this.getLineList.down.length;i++){
					let test=this.getLineList.down[i].file
					if(test.nowsize<test.size){
						obj.down++
					}
				}
				return obj
			}
		},
		created() {
			this.tabinit()
		},
		async  mounted() {
			this.setsize()
			window.addEventListener('resize',this.setsize)
			window.addEventListener("beforeunload",this.beforeunload)
			try {
				await this.$router.push({name:this.getrouter[this.getindex]})
			} catch {
				console.log("页面刷新")
			}
		},
		destroyed() {
			window.removeEventListener('resize',this.setsize)
			window.removeEventListener("beforeunload",this.beforeunload)
		}
	}
</script>

<style scoped>
.mymenu{
	overflow-x: hidden;
	overflow-y: scroll;
	scrollbar-width: none;
	-ms-overflow-style: none;
	padding:0px;
}
.mymenu::-webkit-scrollbar {
    display: none; /* Chrome Safari */
}
</style>
